import {createTheme} from '@mui/material/styles';


export const theme = createTheme({
    palette: {
        primary: {
            main: "#FF7F3B",
            light: '#e8e8e8',
        },
        secondary: {
            main: "#124F46",
        },
        info: {
            main: "#fff",
        },
        success: {
            main: "#9E9DA2"
        },
        action: {
            main: "#FFF"
        }

    },
    typography: {
        fontFamily: ['Kanit', 'sans-serif'].join(','),
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6,
                    //  backgroundColor: '#ffffff30',

                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,

                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10,
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
                color: "secondary"
            },
            styleOverrides: {
                root: {
                    borderBottomLeftRadius: 10,
                    borderTopLeftRadius: 0,
                    borderBottomRightRadius: 10,
                    borderTopRightRadius: 10,
                    fontWeight: 500,
                    paddingRight: 24,
                    paddingLeft: 24,
                    paddingBottom: 12,
                    paddingTop: 12,
                    fontSize: 18,
                    textTransform: "none",
                    color: "#fff",

                },

            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#FF7F3B"
                }
            }
        }

    }


})
